import { PrismaClient } from "@prisma/client";

/**
 * Defines a raw prisma client.
 *
 * This should not be accessed on its own, use the extended client instead
 */

export const prismaClientRaw = new PrismaClient({
    log: process.env.NODE_ENV === "development" ? ["error", "warn"] : ["error"],
});
